import React, {FC} from "react";
import * as fa from "@fortawesome/free-solid-svg-icons"
import {useApi} from "../api/APIContext";
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import { Input } from "@traas/lib/src/components/form/Input";
import {ValidationError} from "../api/api";
import {Team} from "../../../lib/src/api/dto/Team"


export const EditTeamModal: FC<{team: Team}> = ({team}) => {
  const {editTeam} = useApi()
  const [name, setName] = React.useState(team.name)
  const [capacity, setCapacity] = React.useState(team.capacity ?? 0)
  const [errors, setErrors] = React.useState<string[]>([])
  const confirm = async () => {
    await editTeam(team.id, name, team.category, capacity)
      .catch(e => {
        if (e instanceof ValidationError) {
          setErrors(Object.values(e.errors).flat())
        }
        throw e
      })
  }

  return <form>
    <div className={"space-y-2"}>
      <Input label={'Naam'} value={name} focus={true} onChange={setName} type={'text'} />
      {errors.length > 0 && <div className={"text-red-600 text-sm"}>
        {errors.map((e, i) => <p key={i}>{e}</p>)}
      </div>}
      <Input type={"number"} value={capacity} label={'Team capaciteit'} onChange={setCapacity} />
      <ModalFooter icon={fa.faSave} text={"Opslaan"} onSubmit={confirm} />
    </div>
  </form>
}
